import { render, staticRenderFns } from "./dice.vue?vue&type=template&id=59c5c82d&scoped=true&"
import script from "./dice.vue?vue&type=script&lang=js&"
export * from "./dice.vue?vue&type=script&lang=js&"
import style0 from "./dice.vue?vue&type=style&index=0&id=59c5c82d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5c82d",
  null
  
)

export default component.exports